import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import Helmet from 'react-helmet'

// Actions
import { userActions, orderActions } from 'redux/actionCreators'

// Components
import { Heading, RadioButtonGroup, FormGroup, Loader } from 'components'
import Select from 'react-select'
import 'react-select/dist/react-select.css'

import classes from './Payment.scss'

// Helpers
import { validateRequired, hasError, allowNumberOnly, inputProps } from 'helpers/formHelpers'
import _get from 'lodash.get'

const BANK_ACCOUNT_OPTIONS = [
  { icon: '/images/ktb.png', title: 'บัญชีออมทรัพย์ ธนาคารกรุงไทย', number: '204-0-44115-8', branch: 'สาขาจันทบุรี', value: '2040441158' },
  { icon: '/images/bay.png', title: 'บัญชีออมทรัพย์ ธนาคารกรุงศรี', number: '027-1-76696-5', branch: 'สาขาจันทบุรี', value: '0271766965' },
  { icon: '/images/kbank.png', title: 'บัญชีออมทรัพย์ ธนาคารกสิกรไทย', number: '008-3-26627-9', branch: 'สาขาถนนศรีรองเมือง จันทบุรี', value: '0083266279' },
  { icon: '/images/tmb.png', title: 'บัญชีออมทรัพย์ ธนาคารทหารไทย', number: '627-2-34729-2', branch: 'สาขาถนนเบญจมราชูทิศ จันทบุรี', value: '6272347292' },
  { icon: '/images/scb.png', title: 'บัญชีออมทรัพย์ ธนาคารไทยพาณิชย์', number: '514-2-57492-3', branch: 'สาขาจันทบุรี', value: '5142574923' },
  { icon: '/images/nbank.png', title: 'บัญชีออมทรัพย์ ธนาคารธนชาต', number: '615-6-06932-2', branch: 'สาขาจันทบุรี', value: '6156069322' }
]
const BANK_DOMS = BANK_ACCOUNT_OPTIONS.map(option => ({
  value: option.value,
  dom: (
    <span className={classes.bankRow}>
      <img role='presentation' className={classes.icon} src={option.icon} />
      <div className={classes.bankInfo}>
        <div className={classes.title}>{option.title}</div>
        <div className={classes.number}>{option.number}</div>
        {/* <div className={classes.branch}>{option.branch}</div> */}
      </div>
    </span>
  )
}))

const FIELD_NAMES = ['paymentDate', 'paymentTime', 'amount']

const mapStateToProps = (state, ownProps) => ({
  notifying: _get(state, ['payment', 'notifying']) || false,
  notified: _get(state, ['payment', 'notified']) || false,
  orders: _get(state, ['order', 'orders']) || [],
  initialValues: {
    orderId: _get(ownProps, ['location', 'query', 'orderId'])
  }
})
const mapDispatchToProps = (dispatch) => ({
  attemptNotifyPayment: (payload) =>
    dispatch(userActions.attemptNotifyPayment(payload)),
  attemptFindOrders: (payload) =>
    dispatch(orderActions.attemptFindOrders(payload))
})

@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({ form: 'Payment', fields: FIELD_NAMES })
class Payment extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    attemptNotifyPayment: PropTypes.func.isRequired
  };
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {
      bankAccount: BANK_ACCOUNT_OPTIONS[0].value,
      orderId: _get(props, ['location', 'query', 'orderId'])
    }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  componentWillMount () {
    this.props.attemptFindOrders({ status: 'checking' })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.notified !== nextProps.notified) {
      FIELD_NAMES.forEach(fieldName => {
        nextProps.fields[fieldName].onChange('')
      })
    }
    if (!this.props.notified && nextProps.notified) {
      this.setState({ notified: true })
    }
  }

  _onBankAccountChange = (bankAccount) => this.setState({ bankAccount });

  _onTransferSlipChoose = (e) => {
    this.setState({ transferSlip: e.currentTarget.files[0] })
  }

  _validateInput = () => {
    const { attempting, fields } = this.props
    let error = FIELD_NAMES.reduce((error, fieldName) => ({
      ...error, ...validateRequired(fields[fieldName].value, fieldName)
    }), {})
    error = { ...error, transferSlipError: this.state.transferSlip ? '' : 'จำเป็นต้องแนบไฟล์' }
    error = { ...error, orderIdError: this.state.orderId ? '' : 'จำเป็นต้องกรอกข้อมูล' }

    this.setState(error)
    return !attempting && !hasError(error)
  }

  _onSubmit = () => {
    const { attemptNotifyPayment, fields } = this.props
    if (this._validateInput()) {
      attemptNotifyPayment(FIELD_NAMES.reduce((payload, fieldName) => ({
        ...payload, [fieldName]: fields[fieldName].value
      }), {
        accountNumber: this.state.bankAccount,
        transferSlip: this.state.transferSlip,
        orderId: this.state.orderId
      }))
    }
  }

  _onOkay = () => this.context.router.replace('/');

  render () {
    const { notifying, orders } = this.props
    const { paymentDate, paymentTime, amount } = this.props.fields
    return (
      <section id='payment'>
        <Helmet title='แจ้งการชำระเงิน' />
        <Heading>แจ้งการชำระเงิน</Heading>
        <div className={classes.container}>
          <div className='text-center'>
            <div className={classes.bankAccountSelector}>
              <div className={classes.colLeft}>
                <span>สามารถโอนเข้าบัญชี</span>
              </div>
              <div className={classes.colRight}>
                <RadioButtonGroup name='bankAccount'
                  radioClassName={classes.radioButton}
                  selectedValue={this.state.bankAccount}
                  onChange={this._onBankAccountChange}
                  options={BANK_DOMS} />
              </div>
            </div>
          </div>
          <div className='text-center'>
            <div className={classes.form}>
              <FormGroup title='วันที่ชำระเงิน' errorMessage={this.state.paymentDateError}>
                <input type='text' placeholder='เช่น 20/01/2560' {...inputProps(paymentDate)} />
              </FormGroup>
              <FormGroup title='เวลา (โดยประมาณ)' errorMessage={this.state.paymentTimeError}>
                <input type='text' placeholder='เช่น 13.57' {...inputProps(paymentTime)} />
              </FormGroup>
              <FormGroup title='จำนวนเงิน (บาท)' errorMessage={this.state.amountError}>
                <input type='text' placeholder='เช่น 20000' {...allowNumberOnly(amount, true)} />
              </FormGroup>
              <FormGroup title='หลักฐานการโอนเงิน' errorMessage={this.state.transferSlipError}>
                <div className='file-chooser' onClick={() => this.refs.transferSlipChooser.click()}>
                  <input type='file' ref='transferSlipChooser' onChange={this._onTransferSlipChoose} />
                  <div className='file-chooser-left'>เลือกไฟล์</div>
                  <div className='file-chooser-right'>
                    {this.state.transferSlip ? this.state.transferSlip.name : 'ไม่ได้เลือกไฟล์ใด'}
                  </div>
                </div>
              </FormGroup>
              <FormGroup title='หมายเลขการสั่งซื้อ' errorMessage={this.state.orderIdError}>
                <Select name='orderId' value={this.state.orderId}
                  clearable={false} placeholder='กรุณาเลือกหมายเลขการสั่งซื้อ'
                  options={orders.map(order => ({ value: order.orderId, label: order.orderId }))}
                  onChange={({ value }) => this.setState({ orderId: value })} />
              </FormGroup>
            </div>
          </div>
          <div className='text-center'>
            <div className={classes.buttons}>
              <div className={classes.btnSubmit} onClick={this._onSubmit}>
                {notifying ? <Loader /> : <span>แจ้งชำระเงิน</span>}
              </div>
            </div>
          </div>
        </div>
        {this.state.notified && (
          <div className='overlay'>
            <div className='overlay-cell'>
              <div className='lightbox'>
                <div className='line1'>
                  <span>การแจ้งชำระเงินเสร็จสมบูรณ์</span>
                </div>
                <div className='line2'>
                  <div>เจ้าหน้าที่จะตรวจสอบ และยืนยันการชำระเงินของท่าน ทางไลน์หรือทางโทรศัพท์ค่ะ</div>
                </div>
                <div className='line3'>
                  <div>พบปัญหาการใช้งานหรือต้องการสอบถามข้อมูลเพิ่มเติม</div>
                  <div>ติดต่อเรา: 063-464-6194-6 วันจันทร์-เสาร์ 9.00-18.00 / Line id: @ccdc</div>
                </div>
                <img className='mascot' src='/images/mascot.png' alt='mascot' />
                <div className='btn-close' onClick={this._onOkay}>X</div>
                <div className='btn-ok' onClick={this._onOkay}>
                  <span>ตกลง</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    )
  }
}

export default Payment



/** WEBPACK FOOTER **
 ** ./src/containers/User/Payment/Payment.js
 **/